import {
  // existing
  SET_USER_APPOINTMENTS,
  SET_USER_APPOINTMENTS_LOADING,
  SET_USER_APPOINTMENTS_LOADED,
  RESET_USER_APPOINTMENTS,
  // new
  SET_HOME_SERVICES,
  SET_HOME_STAFF,
  SET_HOME_DATE_NOW,
  SET_HOME_LOADING,
  SET_HOME_LOADED,
  RESET_HOME,
} from "./type";

// existing action creators
export const setUserAppointments = (appointments) => ({
  type: SET_USER_APPOINTMENTS,
  payload: appointments,
});

export const setUserAppointmentsLoading = (loading) => ({
  type: SET_USER_APPOINTMENTS_LOADING,
  payload: loading,
});

export const setUserAppointmentsLoaded = (loaded) => ({
  type: SET_USER_APPOINTMENTS_LOADED,
  payload: loaded,
});

export const resetUserAppointments = () => ({
  type: RESET_USER_APPOINTMENTS,
});

// new action creators for home data
export const setHomeServices = (services) => ({
  type: SET_HOME_SERVICES,
  payload: services,
});

export const setHomeStaff = (staff) => ({
  type: SET_HOME_STAFF,
  payload: staff,
});

export const setHomeDateNow = (dateNowServer) => ({
  type: SET_HOME_DATE_NOW,
  payload: dateNowServer,
});

export const setHomeLoading = (loading) => ({
  type: SET_HOME_LOADING,
  payload: loading,
});

export const setHomeLoaded = (loaded) => ({
  type: SET_HOME_LOADED,
  payload: loaded,
});

export const resetHome = () => ({
  type: RESET_HOME,
});
